import React from 'react';
import {
  InputLabel,
  withStyles,
  Box,
  MuiThemeProvider,
} from '@material-ui/core';
import useTranslateText from '../use_translate_text';
import MuiPhoneNumber from 'material-ui-phone-number';
import { styles } from './styles';
import { formLabelsTheme } from '../../style_jsx/styles';

const PhoneNumber = (props) => {
  const { classes, value, phone_Number_Check, required, phoneError, inputRef, helperText, fieldName, mfaService,
          autoComplete, name, setStateData, handlePhoneChange, nolabel, placeholder, onKeyPress, classes_placeholder, disbaled } = props,
        { translateText } = useTranslateText();

  return (
    <>
      <MuiThemeProvider theme={formLabelsTheme}>
        {!nolabel && <InputLabel formlabelclasses={{
          asterisk: required && classes.labelAsterisk,
        }} required = {required}
        component="legend" className="labels mt-3">

          {`${translateText(`${fieldName}`)}:`}

        </InputLabel>}
        <MuiPhoneNumber
          id="outlined"
          InputProps={{
            className: classes.input,
            classes: {
              notchedOutline: inputRef ? classes.notchedOutline : null,
              focused: classes.focused,
              input: classes_placeholder,
            },
          }}
          disableDropdown={true}
          autofocus
          placeholder= {placeholder || '-'}
          variant="outlined"
          disableCountryCode={true}
          type="text"
          autoComplete={autoComplete}
          name={name}
          countryCodeEditable={true}
          isValid={() => true}
          defaultCountry="us"
          onlyCountries={['us']}
          onKeyPress={onKeyPress}
          value={value}
          onChange={(phone) => handlePhoneChange && handlePhoneChange(phone, mfaService) || setStateData && setStateData(`${name}`, phone)}
          minLength="15"
          onBlur={phone_Number_Check}
          error={Boolean(phoneError)}
          helperText= {phoneError &&
                <Box style={{ marginLeft: '-1rem', fontSize: '13px' }} component="span">{translateText(helperText)}</Box>}
          rules={{ minLength: 15 }}
          ref={inputRef || null}
          disabled={disbaled}
        />
      </MuiThemeProvider>
    </>
  );
};
export default withStyles(styles)(PhoneNumber);